import '@styles/views/ksjspace.less';
import AppFooter from '@components/app/appFooter';

const KsjSpace = () => {
  const part1List = [
    {
      name: '云端 CAD / BIM 设计建模工具',
      logo: require('@images/ksjspace/1.png').default,
      desc: '以二维绘图/三维建模功能为基础，结合不同阶段的工程实际业务，生成二维图纸和三维模型。',
    },
    {
      name: '云端协同管理平台',
      logo: require('@images/ksjspace/2.png').default,
      desc: '以图纸、模型、文档为对象，匹配工程建设总体业务流程，形成一整套基于云端架构的项目协同管理体系。',
    },
    {
      name: '云端 BIM 应用工具集',
      logo: require('@images/ksjspace/3.png').default,
      desc: '以 BIM 为核心，根据业务场景集成多种应用工具，让 BIM 超越可视化的桎梏，真正在项目实施过程中发挥价值。',
    },
    {
      name: '云端数据资源服务',
      logo: require('@images/ksjspace/4.png').default,
      desc: '以数据为底层，围绕工程全生命周期应用所产生的数据，在一体化的平台内按照既定的业务逻辑进行流转，为参建各方提供数据服务。',
    },
  ];

  const part1ListJSX = part1List.map((item) => {
    return (
      <div key={item.name} className={'part1-item'}>
        <div className="flex ac">
          <img className={'part1-icon'} src={item.logo} alt="" />
          <span className={'part1-name'}>{item.name}</span>
        </div>
        <div className="part1-text">{item.desc}</div>
      </div>
    );
  });

  const part2List = [
    {
      name: '部署快速',
      desc: 'B/S 架构，',
      desc1: '支持公有云和私有化部署',
      logo: require('@images/ksjspace/21.png').default,
    },
    {
      name: '接入方便',
      desc: '通过浏览器访问，',
      desc1: '无需安装软件或插件',
      logo: require('@images/ksjspace/22.png').default,
    },
    {
      name: '上手简单',
      desc: '功能设计贴合业务，',
      desc1: '学习成本低',
      logo: require('@images/ksjspace/23.png').default,
    },
    {
      name: '工具高效',
      desc: '针对不同业务场景，',
      desc1: '平台内置了专业工具',
      logo: require('@images/ksjspace/24.png').default,
    },
    {
      name: '协同便利',
      desc: '自带流程引擎，',
      desc1: '可自定义审批流',
      logo: require('@images/ksjspace/25.png').default,
    },
  ];

  const part2ListJSX = part2List.map((item) => {
    return (
      <div key={item.name} className={'part2-item flex ac jc fcol'}>
        <img className="part2-logo" src={item.logo} alt="" />
        <div className={'part2-name'}>{item.name}</div>
        <div className={'part2-desc'}>{item.desc}</div>
        <div className={'part2-desc'}>{item.desc1}</div>
      </div>
    );
  });
  const part3List = [
    {
      name: 'BIM Windows',
      desc: 'BIM模型轻量化展示和管理平台软件',
      logo: require('@images/ksjspace/bsLogo.png').default,
      url: 'http://www.baidu.com',
      content:
        'BIM Windows（简称BW）是跨世纪自主研发，基于BIM模型的轻量化展示、管理平台。帮助您方便快捷地管理BIM模型及项目图纸、文档等文件，充分调用BIM项目中模型的信息价值。支持移动APP端和电脑PC端，能够让您随时随地管理BIM项目中模型及图纸等文件，能实现DWG、Bentley、Revit、Catia、IFC等二维图纸和三维模型的秒速转换和便捷浏览。',
    },
    {
      name: 'BIM Station',
      desc: '云端设计建模工具',
      logo: require('@images/ksjspace/bwLogo.png').default,
      url: '',
      content:
        'BIM Station是一款云端CAD/BIM设计建模工具，可以帮助用户在浏览器快速实现二维绘图和三维建模功能，无需安装软件或插件。BIM Station既支持点线面等二维元素的编辑，同时支持三维体元素的各种布尔运算，还具备三维辅助定位和自定义坐标系等功能，可在此基础上开发工程各专业的轻量化设计工具。',
    },
  ];
  const part3ListJSX = part3List.map((item) => {
    return (
      <div key={item.name} className={'part3-item'}>
        <div className="flex ac">
          <img className="part3-logo" src={item.logo} alt="" />
          <div className="part3-title flex jsb fcol">
            <div className={'part3-name'}>{item.name}</div>
            <div className={'part3-desc'}>{item.desc}</div>
          </div>
        </div>
        <div className="part3-content">{item.content}</div>
        <a className="aBtn" href={item.url}>
          查看详情
        </a>
      </div>
    );
  });

  const part4List = [
    {
      name: '可视化工程网盘',
      imageUrl: require('@images/ksjspace/41.png').default,
    },
    {
      name: '设校审一体化协同平台',
      imageUrl: require('@images/ksjspace/42.png').default,
    },
    {
      name: '路桥隧参数化建模',
      imageUrl: require('@images/ksjspace/43.png').default,
    },
    {
      name: '大临设施选址及场地平整、便道设计',
      imageUrl: require('@images/ksjspace/44.png').default,
    },
    {
      name: '临建场地布置',
      imageUrl: require('@images/ksjspace/45.png').default,
    },
    {
      name: '施工模型深化',
      imageUrl: require('@images/ksjspace/46.png').default,
    },
    {
      name: '施工仿真模拟',
      imageUrl: require('@images/ksjspace/47.png').default,
    },
    {
      name: '施工计划及进度管理',
      imageUrl: require('@images/ksjspace/48.png').default,
    },
  ];
  const part4ListJSX = part4List.map((item) => {
    return (
      <div className="part4-item">
        <div>
          <div className="flex ac">
            <img
              className="part4-icon"
              src={require('@images/ksjspace/part4-icon.png').default}
              alt=""
            />
            <div className="part4-name">{item.name}</div>
          </div>
          <img className="part4-image" src={item.imageUrl} alt="" />
        </div>
      </div>
    );
  });
  const part5List = [
    {
      name: '建设单位',
      imageUrl: require('@images/ksjspace/51.png').default,
    },
    {
      name: '设计单位',
      imageUrl: require('@images/ksjspace/52.png').default,
    },
    {
      name: '施工单位',
      imageUrl: require('@images/ksjspace/53.png').default,
    },
    {
      name: '咨询单位',
      imageUrl: require('@images/ksjspace/54.png').default,
    },
  ];
  const part5ListJSX = part5List.map((item) => {
    return (
      <div className="part5-item flex ac">
        <img className="part5-logo" src={item.imageUrl} alt="" />
        <div className="part5-name">{item.name}</div>
      </div>
    );
  });
  return (
    <div className="ksjspace-page">
      <div className="section1">
        <div className="content-title">
          <img className="toplogo" src={require('@images/ksjspace/kj-logo.png').default} alt="" />
          <div className="title">跨界云空间</div>
          <div className="desc">跨越现实，无以为界</div>
          <div className="banner-box">
            <img className="banner" src={require('@images/ksjspace/topimg.png').default} alt="" />
            <div className="b-title">跨界云空间</div>
            <div className="b-desc">跨越现实，无以为界</div>
          </div>
          <div className="button">申请试用</div>
        </div>
      </div>
      <div className="section2">
        跨界云空间以 BIM
        为核心，以数据为底层，集成了建设工程在不同阶段所需要的多种应用工具。在方案阶段，可实现路桥隧的参数化快速建模；在设计阶段，不仅具备基础二维绘图和三维建模功能，还可实现设校审流程配置及一体化审批；在施工阶段，可实现大临设施辅助选址、场地平整、便道设计、场地布置，以及模型深化、施工模拟、计划及进度管理等功能；在运维阶段，可复用设计和施工阶段的数据，为运维决策提供支撑；通过收集工程项目全生命周期的数据，形成企业的数字资产。
      </div>
      <div className="flex jc">
        <video
          className="video"
          poster="http://ksj.com.cn/sitefiles/library/images/2023/2/cb502f2f0d637223.png"
          controls
          muted
        >
          <source
            src="http://ksj.com.cn/sitefiles/library/videos/2023/2/9264101da93d9d07.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <div className="section3 flex jc ac fcol">
        <div className="section-title">跨越现实 无以为界</div>
        <div className="red-line flex jc"></div>
        <div className="part1ListBox flex fcol ac">{part1ListJSX}</div>
      </div>
      <div className="section4">
        <span>
          跨界云空间以 BIM Windows（BIM+GIS 图形引擎）和 BIM
          Station（云端设计建模工具）为基础，构建了工程建设全生命周期的各项应用。从路桥隧参数化建模开始，面向设计业务线提供云端设计建模工具、设校审一体化、数字化交付等功能。面向施工业务线，提供施工组织模拟、工程项目管理、数字化交付等功能。不同产品线的功能模块互相独立、数据互通，从而形成工程全生命周期管理的数字底座。
        </span>
        <img
          className="circle-image"
          src={require('@images/ksjspace/ksjspacecircle.png').default}
          alt=""
        />
      </div>
      <div className="section5 flex wrap jsb">{part2ListJSX}</div>
      <div className="section6 flex fcol ac">{part3ListJSX}</div>

      <div className="flex fcol jc ac">
        <div className="section-title">核心功能</div>
        <div className="red-line"></div>
        <div className="part4ListBox">{part4ListJSX}</div>
      </div>
      <div className="section7 flex fcol jc ac">
        <div className="section-title">客户案例</div>
        <div className="red-line"></div>
        <img src={require('@images/ksjspace/water1.png').default} alt="" className="waterImage" />
        <div className="water-item1">
          <div className="title">某电气化公司模型轻量化及工程管理平台</div>
          <div className="content">
            随着数字化转型的不断深入，某电气化工程公司基于实际的设计和施工业务，以 BIM+ GIS 三维引擎
            BIM
            Windows为基础，开发了一款符合铁路四电专业业务需求的模型轻量化展示及工程项目管理平台，可基于
            BIM 实现进度管理、工程量统计、施工数据挂接等场景化功能。
          </div>
        </div>
        <div className="water-item2">
          <div className="title">某水利院三维数字化设计协同平台</div>
          <div className="content">
            某水利规划设计研究院基于跨界云空间开发了三维模型设校审一体化协同平台，实现了设计环节的数字化管理。
          </div>
        </div>
      </div>
      <div className="flex fcol jc ac">
        <div className="section-title">适用客户</div>
        <div className="red-line"></div>
        <div className="part5ListBox flex jsb wrap">{part5ListJSX}</div>
      </div>
      <AppFooter />
    </div>
  );
};

export default KsjSpace;
